import { useTranslation } from "react-i18next";

export function AdminBookingsTable({ bookings }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-card border border-border overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-sand"><tr className="text-left text-muted2 font-bold text-xs uppercase"><th className="p-3">{t("dash.ref")}</th><th className="p-3">{t("dash.vehicleCol")}</th><th className="p-3 hidden sm:table-cell">{t("dash.clientCol")}</th><th className="p-3">{t("dash.amount")}</th><th className="p-3">{t("dash.statusCol")}</th></tr></thead>
        <tbody>
          {bookings.map((b) => (
            <tr key={b.id} className="border-t border-border font-body">
              <td className="p-3 font-mono text-xs">{b.ref}</td>
              <td className="p-3 font-semibold text-ink">{b.vehicle_name}</td>
              <td className="p-3 hidden sm:table-cell text-muted2 text-xs">{b.driver_email}</td>
              <td className="p-3 font-bold text-canard-dark">{b.amount} €</td>
              <td className="p-3"><span className={`text-xs font-bold px-2 py-0.5 rounded-full ${b.status === "confirmed" ? "bg-emeraude/15 text-emeraude-dark" : b.status === "cancelled" ? "bg-red-100 text-red-600" : "bg-yellow-100 text-yellow-700"}`}>{b.status}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
